<script>
export const sideDrawer = {
  topNavHeight:"120px",
  outerClasses:"rvit-side-nav-drawer"
}

export default { name: "theme-navbar" };
</script>